import { createAction } from 'redux-act';
import { TLegacyErrors } from '@alycecom/services';
import { createAsyncAction, StateStatus } from '@alycecom/utils';

import { ICredentialsErrors, ICredentialsParams } from './credentials.types';

const prefix = 'ACCEPT_GIFT_CODE/CREDENTIALS';

export const checkCredentials = createAsyncAction<ICredentialsParams, StateStatus, TLegacyErrors<ICredentialsErrors>>(
  `${prefix}/CHECK`,
);

export const setIsWrongActivateEmail = createAction<boolean>(`${prefix}/SET_IS_WRONG_ACTIVATE_EMAIL`);
